import { Type } from 'class-transformer';
import { IsInt, IsNotEmpty, IsOptional, IsUUID } from 'class-validator';

export class PosScanCreateDto {
  @Type(() => Number)
  @IsInt()
  @IsNotEmpty()
  merchantId: number;

  @IsUUID()
  @IsOptional()
  scanId: string;
}